import type { WorkflowBaseTriggerFieldDTO } from '../workflowBaseTrigger.types';

export class WorkflowBaseTriggerFieldDTOModel {
  private readonly _dto: WorkflowBaseTriggerFieldDTO;

  constructor(dto: WorkflowBaseTriggerFieldDTO) {
    this._dto = dto;
  }

  get originDTO(): WorkflowBaseTriggerFieldDTO {
    return this._dto;
  }

  get dataType(): DataType {
    return this._dto.dataType || 'STRING';
  }

  get defaultValue(): string {
    return this._dto.defaultValue || '';
  }

  get description(): string {
    return this._dto.description || '';
  }

  get displayName(): string {
    return this._dto.displayName || '';
  }

  get isConditionValue(): boolean {
    return this._dto.isConditionValue || false;
  }

  get name(): string {
    return this._dto.name || '';
  }

  get referencePath(): string {
    return this._dto.referencePath || '';
  }

  get resourceType(): string {
    return this._dto.resourceType || '';
  }
}
